import { EDITORIAL_WORKSPACES } from "./editorialWorkspaceNavigationV1.mjs";
import { EDITORIAL_MASTER_SHOWCASE_ID } from "./editorialAuthorStartV1.mjs";

const ALLOWED_WORKSPACES = new Set(EDITORIAL_WORKSPACES.map((s) => s.key));

export function validEditorialWorkspace(key) {
  return ALLOWED_WORKSPACES.has(key) ? key : null;
}

// One existing Owner QA reference, shared as a non-copying entry point.
// Nothing here creates or re-links a volume, material, grant, or Book page.
export function editorialShowcaseEntry(spaceKey) {
  const valid = validEditorialWorkspace(spaceKey);
  if (!valid) return null;
  return {
    path: "/admin/editorial-v2/materials/" + encodeURIComponent(EDITORIAL_MASTER_SHOWCASE_ID)
      + "?from_workspace=" + encodeURIComponent(valid) + "&showcase=1",
    state: { returnSpace: valid },
  };
}

export function availableShowcaseMaterial(materials) {
  return Array.isArray(materials)
    && materials.some((material) => material?.id === EDITORIAL_MASTER_SHOWCASE_ID);
}

export function editorialShowcaseDisplayMode({ materialId, sourceSpace, showcase } = {}) {
  const space = validEditorialWorkspace(sourceSpace);
  return {
    sourceSpace: space,
    // The shared QA fixture belongs to the old Open Library technical volume.
    // When opened from another product it is a reference gallery ONLY.
    referenceOnly: materialId === EDITORIAL_MASTER_SHOWCASE_ID
      && !!space && space !== "open-library" && showcase === true,
    backPath: space ? "/admin/editorial?space=" + encodeURIComponent(space) : "/admin/editorial",
  };
}
